import { noneAuthGet, noneAuthPost, authGet } from "./tools";

class ArticleService {
	static getArticle = async (id) => {
		const res = await noneAuthPost(`/app/articles/getArticle/${id}`);
		return res.data;
	};

	static getLessonArticle = async (id) => {
		const res = await authGet(`/app/lesson/getLessonByLessonId/${id}`);
		return res.data;
	};

}
export default ArticleService;
